//import logo from './logo.svg';
import './App.css';
import GameState from './GameState';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <GameState />
      </header>
    </div>
  );
}

export default App;
